import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

import {PersistGate} from 'redux-persist/integration/react';
import {Provider} from 'react-redux';
import store, {persistor} from './reducers/Store';

// Importer axios et configurer l'intercepteur
import axios from 'axios';
import { UserActions } from './actions';

// Intercepteur pour les réponses axios
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
    // Vérifier si c'est une erreur 401 (non autorisé)
        if (error.response && error.response.status === 401) {
            // Récupérer le dispatch depuis le store
            const dispatch = store.dispatch;

            // Déconnecter l'utilisateur
            UserActions.logOut(dispatch);
        }

        return Promise.reject(error);
    }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App/>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
